import { normalizeSlotLabel } from "./slotLabel";

/** Priority labels first (deduped), then remaining org suggestions sorted. */
export function orderSlotLabelSuggestions(
  all: readonly string[],
  priority: readonly string[],
): { priority: string[]; rest: string[] } {
  const priorityNorm = [
    ...new Set(priority.map((s) => normalizeSlotLabel(s)).filter(Boolean)),
  ];
  const prioritySet = new Set(priorityNorm);
  const rest = [
    ...new Set(
      all
        .map((s) => normalizeSlotLabel(s))
        .filter((s): s is string => Boolean(s) && !prioritySet.has(s)),
    ),
  ].sort((a, b) => a.localeCompare(b));
  return { priority: priorityNorm, rest };
}
